export default __webpack_public_path__ + "static/media/twitter.8926ec40.png";